var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("v-container", { attrs: { "grid-list-xl": "" } }, [
        _c("div", { staticClass: "text-center mt-7 mb-7" }, [
          _c("h2", [_vm._v("Kellnerruf erfolgreich")]),
        ]),
        _c(
          "div",
          { staticClass: "indented text-center" },
          [
            _c("div", { staticClass: "icon icon--order-success svg" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "72",
                    height: "72",
                    viewBox: "0 0 72 72",
                  },
                },
                [
                  _c("circle", {
                    attrs: {
                      stroke: "#50A92F",
                      "stroke-width": "2",
                      cx: "36",
                      cy: "36",
                      r: "34",
                      fill: "none",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      fill: "#50A92F",
                      d: "M52.5 21.4c-.9-.6-2.1-.5-2.8.2l-20.7 20.2-4.7-5.1c-.8-.8-2.4-1.2-3.5-.5-1.1.9-1.2 2.3-.5 3.5 0 0 5.1 8.7 5.7 9.7s1.6 1.6 3 1.6c1.1 0 2-.6 2.9-1.6.7-.8 20.8-25.3 20.8-25.3.6-.7.6-2-.2-2.7z",
                    },
                  }),
                ]
              ),
            ]),
            _c(
              "v-btn",
              { staticClass: "btn-df okBtn mt-7", on: { click: _vm.ok } },
              [_vm._v("OK")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }